import DOMPurify from 'dompurify';

/**
 * The one place admin-authored HTML is made safe to render.
 *
 * Legal document content moved from plain text to Quill-authored HTML (see
 * `admin/RichTextEditor.vue`) — a deliberate reversal of this codebase's
 * previous "never markup" rule for that field. `KycStatus`-guarded admin
 * accounts author it, but it still reaches every visitor's browser via
 * `v-html`, so it is sanitized on the way out rather than trusted because the
 * writer is privileged: a compromised admin session or a stored-XSS bug
 * upstream should not become a stored-XSS bug downstream too.
 */
export function sanitizeHtml(raw: string): string {
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
}
